// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueDocumentationGenerales = (value) => ({
  type: actionTypes.SET_VALUE_DOCUMENTATION_GENERALES,
  payload: value,
});

export const setCategorieDocumentationGenerales = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_DOCUMENTATION_GENERALES,
  payload: categorie,
});

export const setTypeDocumentationGenerales = (type) => ({
  type: actionTypes.SET_TYPE_DOCUMENTATION_GENERALES,
  payload: type,
});

export const setAnneeDocumentationGenerales = (annee) => ({
  type: actionTypes.SET_ANNEE_DOCUMENTATION_GENERALES,
  payload: annee,
});

export const setCurrentPageDocumentationGenerales = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_DOCUMENTATION_GENERALES,
  payload: page,
});

export const setOrderDocumentationGenerales = (order) => ({
  type: actionTypes.SET_ORDER_DOCUMENTATION_GENERALES,
  payload: order,
});

export const setSortFieldDocumentationGenerales = (field) => ({
  type: actionTypes.SET_SORT_FIELD_DOCUMENTATION_GENERALES,
  payload: field,
});
